import { render, staticRenderFns } from "./how-to-lock-individual-chats-in-gb-whatsapp.vue?vue&type=template&id=030ed2b9"
import script from "./how-to-lock-individual-chats-in-gb-whatsapp.vue?vue&type=script&lang=js"
export * from "./how-to-lock-individual-chats-in-gb-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports